// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup[data-v-d6fe6d7c]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:10}.action-btn[data-v-d6fe6d7c]{width:100%}", ""]);
// Exports
module.exports = exports;
